import React, { useEffect, useState } from 'react';
import './ProductImage.scss';
import missingSvg from '../../assets/svgs/missing.svg';
import loadingSvg from '../../assets/svgs/loading.svg';
type Props = {
  imageCode?: string;
  imageAlt?: string;
  className?: string;
};

const ProductImage = (props: Props) => {
  const {
    imageCode = '',
    imageAlt = '',
    className = '',
  } = props;

  const [imgSource, setImageSource] = useState(loadingSvg);
  const getImgSource = async () => {
    let finalSrc = missingSvg;
    if (imageCode) {
      const result = await fetch(`/img/${imageCode}.jpg`, { method: 'HEAD' });
      if (result.ok) {
        finalSrc = `/img/${imageCode}.jpg`;
      }
    }
    // else {
    //   const resultTwo = await fetch(`img/${imageCode}.png`, { method: 'HEAD' });
    //   if (resultTwo.ok) {
    //     finalSrc = `img/${imageCode}.png`;
    //   }
    // }
    setImageSource(finalSrc);
  };

  useEffect(() => {
    getImgSource();
  }, [imageCode]);
  return (
        <>
            <img src={imgSource} className={`${className} lw-image`} alt={imageAlt}/>
        </>
  );
};

export default ProductImage;
